import { oc } from "@orpc/contract";
import { z } from "zod";

const SupplierContactSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  title: z.string().nullable(),
  isPrimary: z.boolean(),
  apRemittance: z.boolean(),
  source: z.enum(["manual", "supplier"]),
});

const AddApRemittanceContactInputSchema = z.object({
  supplierId: z.string().uuid(),
  email: z.string().trim().toLowerCase().pipe(z.email()),
  name: z.string().trim().min(1).optional(),
});

export const supplierContactsContracts = {
  list: oc
    .input(z.object({ supplierId: z.string().uuid() }))
    .output(z.object({ contacts: z.array(SupplierContactSchema) }))
    .route({ method: "GET" }),
  toggleApRemittance: oc
    .input(
      z.object({
        contactId: z.string().uuid(),
        apRemittance: z.boolean(),
      }),
    )
    .output(z.object({ success: z.boolean() }))
    .route({ method: "POST" }),
  addApRemittanceContact: oc
    .input(AddApRemittanceContactInputSchema)
    .output(z.object({ contactId: z.string().uuid() }))
    .route({ method: "POST" }),
} as const;
